import axios from "axios";
import axiosInstance from "./AxiosInstance";

// ✅ Example: GET request with params
export const fetchUserData = async (userId) => {
  try {
    const response = await axiosInstance.get(`api/users/profile`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

// ✅ Example: POST request with body
export const getSubscription = async (postData) => {
  try {
    const response = await axiosInstance.get(`api/subscription/get`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user subscription:", error);
    throw error;
  }
};

export const connectWithGoogle = async (code) => {
  try {
    const response = await axiosInstance.post(`api/google/oauth/callback`, {
      code,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};


export const getCheckoutLink = async (id, code) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_WORDPRESS_DOMAIN}/wp-json/custom-api/v1/get-payment-url`, {
      // 1. Pass query parameters here
      params: { 
        subscription_id: id,
        code: code 
      },
      headers: { 
        Authorization: "Bearer ba1197e987c67aae4af488f1a34fd098" 
      }
    });
    
    return response.data;
  } catch (error) {
    // Corrected error message to match the function's purpose
    console.error("Error fetching checkout link:", error);
    throw error;
  }
};


